<template>
  <v-card :height="210">
    <v-card-title class="mb-0 pb-1">
      Invoice Details
      <v-spacer></v-spacer>
    </v-card-title>

    <!-- Check if invoice exists -->
    <v-card-text v-if="invoice">
      <v-container class="mt-0">
        <v-row>
          <v-col
            v-for="detail in invoiceDetails"
            :key="detail.label"
            cols="12"
            md="3"
            class="mb-4"
          >
            <details-text-shimmer v-show="isLoading" />
            <div v-show="!isLoading">
              <h4 class="font-weight-light">
                {{ detail.label }}
              </h4>
              <h4 class="font-weight-medium">
                <span v-if="detail.filter === 'formatDay'">{{ detail.value | formatDay }}</span>
                <span v-else-if="detail.label === 'Status'">{{ getStatusText(detail.value) }}</span>
                <span v-else>{{ detail.value }}</span>
              </h4>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Display message if invoice is null -->
    <v-card-text v-else>
      <div class="text-center">
        No invoice associated with this payment was found.
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import DetailsTextShimmer from '@/components/partials/shimmers/DetailsTextShimmer.vue'

export default {
  components: {
    'details-text-shimmer': DetailsTextShimmer,
  },
  props: {
    invoice: {
      type: Object,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    invoiceDetails() {
      if (!this.invoice) return []

      return [
        { label: 'Invoice Number', value: this.invoice.invoice_number || 'N/A' },
        { label: 'Total Amount', value: this.invoice.total_amount || 'N/A' },
        { label: 'Due Date', value: this.invoice.due_date || 'N/A', filter: 'formatDay' },
        { label: 'Status', value: this.invoice.status || 0 }, // Default to UNPAID (0) if no status
        { label: 'Invoice Date', value: this.invoice.created_at || 'N/A', filter: 'formatDay' },
      ]
    },
  },
  methods: {
    getStatusText(status) {
      const statusMap = {
        0: 'UNPAID',
        1: 'PAID',
        2: 'OVERDUE',
        3: 'PARTIALLY_PAID',
      }

      return statusMap[status] || 'UNKNOWN'
    },
  },
}
</script>
